import _extends from "@babel/runtime/helpers/extends";
import PropTypes from "prop-types";
import React from "react";
import { Button, H, Text } from "../../components";
import FileItem from "./file-item";
export const FileUpload = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {string} [props.accept]
 * @param {(name: string) => any} props.removeFile
 * @param {{ name: string }[]} props.uploadedFiles
 * @param {(e: MouseEvent) => any} props.nextStep
 * @param {string} [props.name]
 * @param {boolean} [props.multiple]
 * @param {(e) => any} [props.onClick]
 * @param {(e) => any} [props.onChange]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function FileUpload({
  accept,
  removeFile,
  uploadedFiles,
  nextStep,
  ...props
}, ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: "shadow-md w-full bg-white rounded-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "p-4 h-64 flex flex-col items-center justify-center cursor-pointer rounded-lg border-dashed border-2 border-en-gray-600 relative"
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: "opacity-0 w-full h-64 top-0 left-0 absolute cursor-pointer",
    type: "file",
    ref: ref,
    accept: accept
  }, props)), /*#__PURE__*/React.createElement(H, {
    level: 4,
    as: "div",
    className: "cursor-pointer text-center mb-4 md:hidden"
  }, "Select files to upload"), /*#__PURE__*/React.createElement(H, {
    level: 4,
    as: "div",
    className: "cursor-pointer text-center mb-4 hidden md:block"
  }, "Drag & Drop files here to upload"), /*#__PURE__*/React.createElement(Text, {
    variant: "secondary"
  }, "You can only batch upload bills under the same meter account."), /*#__PURE__*/React.createElement("span", {
    className: "rounded p-2 bg-en-gray-100 font-bold"
  }, "Browse Files"))), uploadedFiles && uploadedFiles.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p-4 file-list-container overflow-x-scroll"
  }, /*#__PURE__*/React.createElement(H, {
    level: 4,
    as: "h3",
    className: "text-center"
  }, "Selected Files"), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap justify-center md:justify-start"
  }, [...uploadedFiles].map(file => /*#__PURE__*/React.createElement(FileItem, {
    removeFile: removeFile,
    name: file.name,
    key: file.name
  })))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 flex justify-center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: e => nextStep(e),
    className: "w-full max-w-md"
  }, "Upload Files"))));
});
FileUpload.propTypes = {
  accept: PropTypes.string,
  removeFile: PropTypes.func,
  uploadedFiles: PropTypes.array,
  nextStep: PropTypes.func
};
export default FileUpload;